import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Drawer } from '@mui/material';
// utils
import cssStyles from '../../../../utils/cssStyles';
// config
import { NAVBAR } from '../../../config';
// hooks
import { useResponsive, useCollapseDrawer } from '../../../../shared/hooks';
// components
import { Scrollbar } from '../../../../shared/components/base';
import SidebarNavigation from './SidebarNavigation';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------

NavbarVertical.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};
export default function NavbarVertical({ isOpenSidebar, onCloseSidebar }) {
  const theme = useTheme();
  const { pathname } = useLocation();
  const isDesktop = useResponsive('up', 'lg');
  const { isCollapse, collapseHover, onHoverEnter, onHoverLeave } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        paddingTop: 10,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' },
      }}
    >
      <SidebarNavigation />
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH,
        },
      }}
    >
      {!isDesktop && (
        <>
          <Drawer
            anchor="left"
            open={open}
            onClose={handleDrawerToggle}
            PaperProps={{
              sx: {
                width: NAVBAR.DASHBOARD_WIDTH,
                boxShadow: (theme) => theme.customShadows.z24,
              },
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {renderContent}
          </Drawer>
        </>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              borderRightStyle: 'dashed',
              bgcolor: 'background.default',
              transition: (theme) =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.standard,
                }),
              ...(isCollapse && {
                width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
              }),
              ...(collapseHover && {
                ...cssStyles(theme).bgBlur(),
                boxShadow: (theme) => theme.customShadows.z24,
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
